import React from "react";
import { Dialog, DialogContent, Stack, Typography, FormControlLabel, Checkbox } from "@mui/material";
import { AskAMIBotIcon } from "Icons/Icons";
import TermsOfUse from "./TermsOfUse";
import { FormFooter } from "Common/Components";

interface ITermsAndConditionsProps {
  openTermsAndConditions: boolean;
  handleAcceptTerms: () => void;
  handleTermsCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isChecked: boolean;
  isLoading: boolean;
  hasAcceptedTerms?: boolean;
  handleCloseTerms?: () => void;
  acceptedDate?: string;
  termsOfUsePdfUrl?: string;
}

export const TermsAndConditions = (props: ITermsAndConditionsProps) => {
  const {
    openTermsAndConditions,
    handleAcceptTerms,
    handleTermsCheckboxChange,
    isChecked,
    isLoading,
    hasAcceptedTerms,
    handleCloseTerms,
    acceptedDate,
    termsOfUsePdfUrl,
  } = props;

  const handleDenyTerms = () => {
    window.location.href = import.meta.env.VITE_LANDING_PAGE_URL;
  };

  return (
    <Dialog
      open={openTermsAndConditions}
      aria-labelledby="terms-dialog-title"
      aria-describedby="terms-dialog-description"
      maxWidth="lg"
      fullWidth
      slotProps={{
        paper: {
          variant: "outlined",
          sx: {
            padding: 0,
          },
        },
      }}
    >
      <DialogContent>
        <Stack sx={{ mt: 2, alignItems: "center", overflow: "hidden" }}>
          <AskAMIBotIcon sx={{ width: "36px", height: "36px" }} />
          <Stack spacing={1.5} sx={{ marginTop: 1 }}>
            <Typography
              id="confirm-dialog-title"
              variant="h4"
              sx={{ fontWeight: "fontWeightSemiBold", textAlign: "center" }}
              color="primary.main"
            >
              Terms and Conditions
            </Typography>
          </Stack>
        </Stack>
        <Stack spacing={2} sx={{ mt: 2 }}>
          <TermsOfUse acceptedDate={acceptedDate} termsOfUsePdfUrl={termsOfUsePdfUrl} />
        </Stack>
        {!hasAcceptedTerms && (
          <Stack spacing={1} sx={{ mt: 2 }}>
            <FormControlLabel
              control={<Checkbox checked={isChecked} onChange={handleTermsCheckboxChange} color="primary" sx={{ pr: 2 }} />}
              label="I have read and agree to the Terms and Conditions"
            />
          </Stack>
        )}
      </DialogContent>
      <FormFooter
        buttons={[
          {
            label: "Close",
            onClick: () => handleCloseTerms?.(),
            variant: "contained",
            color: "primary",
            shouldHide: !hasAcceptedTerms,
            hasGap: true,
          },
          {
            label: "Deny",
            onClick: handleDenyTerms,
            variant: "outlined",
            color: "error",
            shouldHide: hasAcceptedTerms,
            hasGap: true,
          },
          {
            label: "Accept",
            onClick: handleAcceptTerms,
            variant: "contained",
            color: "primary",
            isLoading: isLoading,
            disabled: !isChecked || isLoading,
            shouldHide: hasAcceptedTerms,
          },
        ]}
      />
    </Dialog>
  );
};
